import { Box, Button } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { salesManagement } from "../../../config";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { SalesOrderPayments } from "../../../data/DynamicTable/Collumns";

function SaleOrderPaymentMethod() {
  const navigate = useNavigate(); // Initialize navigate hook
  const data = JSON.parse(localStorage.getItem("SaleOrderData"));
  const base_url = salesManagement.uri;
  const actions = {
    entity: "PurchaseOrderItems",
    isSubRight: true,
    showMore: {
    key: "SHOWMORE",
    button_name: "Show More",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
    title: "Sale Order Payment Details",
  },
    dataObject: {
      inputFields: { saleOrderId: data.saleOrderId },
      inputObjectName: "saleOrderPaymentsViewById",
      inputSubObjectName: "saleOrderPaymentsView",
      returnFields: [
        "id",
        "saleOrderId",
        "paymentMethodId",
        "methodName",
        "amount",
        "createdDate",
        "createdBy",
        "customerName",
        "phone",
        "insertedBy",
        "transCode",
      ],
    },

    showStatus: true,
    showPayments: false,
  };
  const ignore = ["createdBy"];
  return (
    <Box m="2px">
      {/* Back Button */}
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate(-1)} // Go back to the previous page
        sx={{ marginBottom: "10px" }}
      >
        Back
      </Button>{" "}
      {/* Dynamic Table */}
      <DynamicTable
        title="Sale Order Payments"
        subtitle="View Payment Methods"
        ignoreFields={ignore}
        // FormComponent={PurchaseOrderItemsForm}
        columns={SalesOrderPayments}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
}
export default SaleOrderPaymentMethod;
